export default __webpack_public_path__ + "static/media/ceramol-iage-result-beauty-routine-lover.9aadcbe6.png";